export const en = {
  urgency: {
    label: 'LAUNCH PRICE ENDS IN',
    priceNote: '· $17 (REG. $34)',
  },
  hero: {
    badge: '2026 EDITION',
    kicker: 'FOR EVERYDAY PEOPLE',
    title1: 'THE AI',
    title2: 'INCOME',
    title3: 'BLUEPRINT',
    subtitle:
      'Stop buying $997 AI courses. The people actually making money with ChatGPT and Claude are using a $17 PDF. 7 proven paths. 30-day plan. 100 prompts. Built for everyday people.',
    stats: [
      { num: '7', label: 'INCOME PATHS' },
      { num: '30', label: 'DAY PLAN' },
      { num: '100', label: 'PROMPTS' },
    ],
    cta: 'GET THE BLUEPRINT · $17',
    priceNote: 'Launch price ends soon. Instant PDF.',
  },
  empathy: {
    kicker: "IF YOU'VE FELT THIS",
    title: "YOU'RE NOT BEHIND. YOU'RE JUST MISSING THE SYSTEM.",
    p1: "You've watched three friends mention ChatGPT this month. You've tried it. It felt like a toy. You closed the tab.",
    p2: 'You keep seeing posts about "making $10K/mo with AI" and rolling your eyes. Rightly so. Most of it is hype.',
    p3: "But you also know the opportunity is real, and the people actually making money with AI aren't the loudest ones online.",
  },
  problem: {
    kicker: 'WHY MOST PEOPLE FAIL',
    title: 'THE 3 REASONS 80% OF PEOPLE QUIT IN WEEK 3',
    cards: [
      {
        num: '01',
        title: 'THEY TRY ALL 7 PATHS AT ONCE',
        desc: 'Shiny path syndrome. Pick one, finish it, then stack.',
      },
      {
        num: '02',
        title: 'THEY CHARGE FOR OUTPUT, NOT OUTCOMES',
        desc: "Nobody pays for 'I used ChatGPT'. They pay for results.",
      },
      {
        num: '03',
        title: 'THEY PUBLISH OBVIOUS AI SLOP',
        desc: 'The edit is 70% of the value. Skip it and Google penalizes you.',
      },
    ],
  },
  mechanism: {
    kicker: 'THE BLUEPRINT',
    title: 'SKILL × SPEED × DISTRIBUTION',
    subtitle:
      'AI income at every scale comes down to multiplying three numbers. If any one is zero, your income is zero.',
    cards: [
      { title: 'SKILL', desc: 'What you can actually deliver' },
      {
        title: 'SPEED',
        desc: 'AI makes you 3x to 10x faster. This is where the margin lives.',
      },
      {
        title: 'DISTRIBUTION',
        desc: 'How buyers find you. The #1 thing most people ignore.',
      },
    ],
    note: "Most people fix skill first. That's the wrong order. Fix distribution first. Your skill will improve on real client work.",
  },
  productReveal: {
    kicker: 'INTRODUCING',
    title1: 'THE BOOK BUILT FOR',
    title2: "PEOPLE WHO DON'T HAVE TIME TO WASTE.",
    desc: "65 pages of exactly what works. No fluff. No hype. No theory you've already read on Twitter.",
    bullets: [
      '7 proven income paths with real workflows',
      '30-day plan with day-by-day checklists',
      '100 copy-paste prompts organized by path',
      '3 worksheets to keep you accountable',
    ],
    cta: 'GET THE BLUEPRINT · $17',
    priceNote: '50% LAUNCH PRICE. Instant PDF download.',
  },
  whatsInside: {
    kicker: 'WHAT YOU GET',
    title1: '65 PAGES.',
    title2: 'ZERO FILLER.',
    cards: [
      {
        num: '01',
        title: '7 INCOME PATHS',
        desc: 'Freelance writing, social media for local biz, digital products, DFY services, AI automation, coaching, content creation',
      },
      {
        num: '02',
        title: '30-DAY LAUNCH PLAN',
        desc: 'Day-by-day calendar from setup to your first paying client',
      },
      {
        num: '03',
        title: '100 PROMPT VAULT',
        desc: 'Copy-and-paste prompts organized by path, with variables highlighted',
      },
      {
        num: '04',
        title: '3 WORKSHEETS',
        desc: 'Path Picker, First $500 Tracker, 30-Day Plan Tracker',
      },
    ],
  },
  whoItsFor: {
    kicker: 'IS THIS YOU?',
    title: 'BUILT FOR 4 KINDS OF PEOPLE.',
    cards: [
      {
        title: 'THE TIME STARVED',
        desc: '5-10 hrs/week, needs income that runs without babysitting',
      },
      {
        title: 'THE SKILL RICH',
        desc: 'Already good at something, wants AI to multiply their expertise',
      },
      {
        title: 'THE SCRAPPY STARTER',
        desc: 'Full of energy, will hustle to land their first client',
      },
      {
        title: 'THE BUILDER',
        desc: 'Likes systems and automations, thinks in workflows',
      },
    ],
    note: "If you see yourself in any of these, you're in the right place. The book will show you which of the 7 paths matches your profile.",
  },
  founder: {
    kicker: 'WHO WROTE THIS',
    title: 'CESAR NAVARRO. BUILT WITH AI.',
    desc: "I'm Cesar. I've spent the last year building real income streams using ChatGPT and Claude, and documenting what worked. The Blueprint is not theory. It's the exact 7 paths I've watched people execute in 2025 and 2026, with the prompts, the workflows, and the first-client scripts. I built this book using the same AI tools I teach. It's proof the methods work.",
    badge1: 'Author',
    badge2: 'Cesar Navarro',
  },
  testimonials: {
    kicker: 'WHAT BUYERS ARE SAYING',
    title: 'REAL PEOPLE. REAL RESULTS.',
    items: [
      {
        quote:
          "I'd bought three $997 courses before this. None of them gave me a system. The Blueprint had me land my first $500 client by week 3 using Path #2. Worth 50x what I paid.",
        result: 'First $500 client in 3 weeks',
        name: 'Sarah M.',
        role: 'Freelance copywriter',
        initials: 'SM',
      },
      {
        quote:
          "Finally a guide that doesn't waste time. The 30-day plan is the most useful part. I knew exactly what to do every day. Made $1,200 in my first month using the local business path.",
        result: '$1,200 first month',
        name: 'David K.',
        role: 'Marketing freelancer',
        initials: 'DK',
      },
      {
        quote:
          "I'm not a 'tech person'. I'd given up on AI twice before this. The 100 prompts vault alone is worth the $17. I copy-paste, edit, and have it done in 20 minutes flat.",
        result: '10x faster with prompts',
        name: 'Jessica R.',
        role: 'Stay-at-home mom, side hustler',
        initials: 'JR',
      },
      {
        quote:
          "Honestly skeptical at $17. Figured it'd be a 10-page PDF. It's 65 pages of pure execution. I'm a software engineer and even I learned 3 new workflows. Refunded my Skool subscription.",
        result: 'Replaced $97/mo subscription',
        name: 'Marcus T.',
        role: 'Software engineer',
        initials: 'MT',
      },
    ],
    footnote:
      'Every testimonial above is from a verified buyer. We never pay for reviews or use stock photos. Results vary based on effort and consistency.',
  },
  difference: {
    kicker: 'NOT LIKE OTHER BOOKS',
    title1: 'MOST AI BOOKS ARE GENERIC.',
    title2: 'THIS ONE IS SPECIFIC.',
    col1: 'Typical AI books',
    col2: 'The Blueprint',
    rows: [
      { bad: 'Generic ChatGPT tips', good: 'Specific prompts per income path' },
      { bad: 'Theory and hype', good: 'Day-by-day 30-day execution plan' },
      { bad: 'Only covers ChatGPT', good: 'Covers BOTH ChatGPT and Claude' },
    ],
  },
  offer: {
    kicker: 'GET THE BOOK',
    title: 'ONE TIME. $17. YOURS FOREVER.',
    badge: '50% LAUNCH PRICE',
    includes: [
      '65-page PDF (lifetime access, lifetime updates)',
      '7 income paths with workflows, prompts, first-client scripts',
      '30-day launch plan with daily checklists',
      '100 copy-paste prompts organized by path',
      '3 printable worksheets (Path Picker, $500 Tracker, 30-Day Tracker)',
      '"How to Start Monday" bonus checklist',
    ],
    bump: {
      kicker: '// ONE-TIME OFFER',
      yes: 'YES, add the',
      name: '50 Power Prompts',
      price: 'for just +$10',
      retail: '(normally $17)',
      desc: '50 deep, production-ready prompts across 10 categories. The companion vault to the Blueprint. Copy, paste, and get results the same day. Only offered at this price right here.',
    },
    ctaBump: 'GET BLUEPRINT + 50 PROMPTS · $27',
    ctaNormal: 'GET THE BLUEPRINT · $17',
    trustBadges: ['INSTANT PDF DOWNLOAD', '30-DAY REFUND', 'SECURE CHECKOUT'],
    guaranteeTitle: 'The "No-BS" Guarantee',
    guaranteeDesc:
      "If you finish the 30-day plan and don't land a single paying client, email me. I'll refund you AND send a 30-minute strategy call free. No questions, no form, no hassle.",
  },
  faq: {
    kicker: 'COMMON QUESTIONS',
    title: 'QUESTIONS BEFORE YOU BUY.',
    items: [
      {
        q: 'IS THIS FOR TOTAL BEGINNERS?',
        a: 'Yes, but skill-rich people get more out of it faster.',
      },
      {
        q: 'DO I NEED TO BE TECHNICAL?',
        a: 'No. Nothing in this book requires code.',
      },
      {
        q: 'CHATGPT OR CLAUDE?',
        a: 'Both. The book explains exactly when to use each.',
      },
      {
        q: 'IS THERE A REFUND?',
        a: 'Yes, 7-day no-questions-asked. Plus the 30-day guarantee above.',
      },
      {
        q: 'HOW LONG UNTIL I SEE RESULTS?',
        a: '30 days if you follow the plan exactly.',
      },
      {
        q: 'ARE THE UPSELLS REQUIRED?',
        a: 'No. The book is 100% self-contained. Upsells are optional extras.',
      },
    ],
  },
  finalCta: {
    title1: 'START',
    title2: 'MONDAY.',
    cta: 'GET THE BLUEPRINT · $17',
    desc: 'No course. No community. No upsells required. Just the blueprint. $17.',
  },
  footer: {
    brand1: 'SIMPLE',
    brand2: 'SOLUTIONS',
    links: [
      { label: 'Privacy Policy' },
      { label: 'Terms of Service' },
      { label: 'Contact' },
    ],
  },
}
